const logout = {
  methods: {
    logout() {
      this.$router.push({ name: 'Logout' })
    }
  }
}

export { logout }
